import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import Colors from "../../../../global/Colors";

const STRINGS = {
  defaultTitle: "Daily KPI Summary",
  defaultUserName: "Unknown",
  defaultUserRole: "Medical Care Coordinator",
  gradientColors: [
    { percent: 0, color: Colors.sky[300] },
    { percent: 10, color: Colors.sky[500] },
    { percent: 15, color: Colors.blue[500] },
    { percent: 45, color: Colors.violet[700] },
    { percent: 80, color: Colors.purple[800] },
  ],
  navigationPaths: { SEARCH: "/search" },
  colors: {
    1: {
      backgroundColor: Colors.green[200],
      textColor: Colors.green[600],
      arrowTextColor: Colors.green[400],
      borderColor: Colors.green[500],
    },
    2: {
      backgroundColor: Colors.red[200],
      textColor: Colors.red[800],
      arrowTextColor: Colors.red[500],
      borderColor: Colors.red[500],
    },
  },
  arrows: {
    1: <ArrowDropDown className={`text-5xl`} />,
    2: "",
    3: <ArrowDropUp className={`text-5xl`} />,
  },
};

export default STRINGS;
